import type { CloudpackCommand } from '../utilities/CloudpackCommand.js';

/**
 * Initialize a command object for a sub-command.
 * This is the type for the `init` function exported by each `src/commands/<name>/index.ts` module.
 * @param program Command object for the program.
 */
export type CommandInitFunction = (program: CloudpackCommand<object, object>) => void;

/**
 * Type for each `src/commands/<name>/index.ts` module.
 */
export type CommandInitModule = {
  init: CommandInitFunction;
};
